import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";
import coreAPIs from "services/api/core";
import { channel } from "store/schemas";

export const getNewsChannels = createAsyncThunk("newsChannel/getNewsChannels", async (payload) => {
  try {
    const response = await coreAPIs.getNewsChannels(payload);

    return {
      ...response.data,
      ...(response.data.statusCode === 200 ? normalize(response.data.data.items || [], [channel]) : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getNewsChannelById = createAsyncThunk("newsChannel/getNewsChannelById", async (payload) => {
  try {
    const response = await coreAPIs.getNewsChannelById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createNewNewsChannel = createAsyncThunk("newsChannel/createNewNewsChannel", async (payload) => {
  try {
    const response = await coreAPIs.createNewNewsChannel(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteNewsChannel = createAsyncThunk("newsChannel/deleteNewsChannel", async (payload) => {
  try {
    const response = await coreAPIs.deleteNewsChannel(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateNewsChannel = createAsyncThunk("newsChannel/UpdateNewsChannel", async (payload) => {
  try {
    const response = await coreAPIs.updateNewsChannel(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
